import * as React from 'react';
import { cn } from '@/lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

/**
 * Shared Textarea primitive (T-202 Slice 8) — the single owner of multi-line text
 * input chrome. Mirrors `Input`'s border/ring/hover/focus tokens so textareas match
 * single-line fields. Replaces bare `<textarea>` and the off-allowlist PrimeReact
 * `InputTextarea` (rule 12 / T-426).
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, rows = 3, ...props }, ref) => {
    return (
      <textarea
        rows={rows}
        className={cn(
          'flex min-h-[5rem] w-full rounded-lg border border-surface/12 bg-surface/[0.02] px-3 py-2 text-sm shadow-sm',
          'ring-offset-background transition-[color,box-shadow,border-color] duration-200',
          'hover:border-surface/20',
          'placeholder:text-muted-foreground/60',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/70 focus-visible:ring-offset-1 focus-visible:border-transparent',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
